module.exports = __webpack_public_path__ + "static/media/procoreLogo.e878916e.svg";